/* Import Leverege Modules */
import ModelUtil from '@leverege/model-util';
import Unit from '@leverege/unit';

/* Import Local Modules */
import Util from "./Util.js"; // These are common, make them once
const base = {
  ...ModelUtil.createAllValue('unit'),
  ...ModelUtil.createAllValue('maxDecimals'),
  ...ModelUtil.createAllValue('fixed'),
  ...ModelUtil.createAllValue('sliding'),
  ...ModelUtil.createAllValue('baseUnit'),
  ...ModelUtil.createAllValue('localize')
};

/**
 * Returns a Model object configured to be 
 * used for the specific type of unit
 */
function createFor(type) {
  function create() {
    const baseUnitTypes = Unit.getBaseUnitTypes(type);
    const defaultBaseUnit = baseUnitTypes.length > 0 ? baseUnitTypes[0].value : null;
    return {
      type: Util.getFormatterTypeForType(type),
      unit: null,
      unitType: type,
      fixed: false,
      maxDecimals: 2,
      sliding: false,
      baseUnit: defaultBaseUnit,
      localize: true
    };
  }
  return {
    create,
    ...base
  };
}
export default {
  createFor,
  ...base
};